import React from "react";

import { DateTime, IColumnData } from "@Utils";
import { Button } from "antd";
import { ICertificateTableData } from "../types";
import { PointsTypes } from "@Models/IPoints";

interface IPrepareCertificateColumnDataProps {
    /**
     * The id of the active download
     */
    activeDownloadId?: string;

    /**
     * Whether the download button is disabled
     */
    isDisabled: boolean;

    /**
     * Downloads the report based on the id
     */
    downloadReport: (id: string, pointsType: PointsTypes) => Promise<void>;
}

/**
 * A function that prepares the column data for the certificate table
 */
const prepareCertificateColumnData = ({
    isDisabled,
    activeDownloadId,
    downloadReport,
}: IPrepareCertificateColumnDataProps): IColumnData<ICertificateTableData>[] => [
    {
        key: "creationDate",
        title: "Date Created",
        render: "date",
        align: "center",
    },
    {
        key: "startDate",
        width: 250,
        title: "Date Range",
        render: (_, { startDate, endDate }) => {
            if (!DateTime(startDate).isBlankDate() && !DateTime(endDate).isBlankDate()) {
                return `${DateTime(startDate).format("MMM Do YYYY")} - ${DateTime(endDate).format("MMM Do YYYY")}`;
            }
            if (!DateTime(startDate).isBlankDate()) {
                return `${DateTime(startDate).format("MMM Do YYYY")}`;
            }
            if (!DateTime(endDate).isBlankDate()) {
                return `${DateTime(endDate).format("MMM Do YYYY")}`;
            }
            return "";
        },
        align: "center",
    },
    {
        key: "points",
        align: "center",
    },
    {
        key: "pointsType",
        title: "Type",
        render: (_, { pointsType }) => {
            return pointsType?.toUpperCase() ?? "CPD";
        },
        align: "center",
    },
    {
        key: "actions",
        align: "center",
        width: 250,
        render: (_, record) => (
            <Button
                className="secondary"
                disabled={isDisabled}
                loading={activeDownloadId === record.id}
                onClick={() => downloadReport(record.id, record.pointsType ?? PointsTypes.CPD)}
            >
                View Report
            </Button>
        ),
    },
];

export default prepareCertificateColumnData;
